import http from "../../../config/axios";

export const postBenefit = (benefit) => {
    const res =  http.post('/admin/benefit',benefit)
    return res;
}

export const patchBenefit = (id, benefit) => {
    const res =  http.patch(`/admin/benefit/${id}`, benefit)
    return res;
}

export const deleteBenefit = (id) => {
    const res =  http.delete(`/admin/benefit/${id}`)
    return res;
}
